import { Inject } from '@angular/core';

import * as SVG from 'svg.js';

import { PartInfo } from 'app/collage-designer/collage-designer-config';
import { StageUtils } from 'app/core/utils.stage';
import { DesignStepService
       } from 'collage-designer/design-step/design-step.service';
import { StageService } from 'collage-designer/stage/stage.service';
import { StageConstants } from 'core/constants';
import { QualityRating } from './quality-rating';

export class ImageQualityRatingService
{
  public constructor(
      @Inject(DesignStepService) private designStepService: DesignStepService,
      @Inject(StageService) private stageService: StageService)
  {}

  public readQualityRating(image: SVG.Image): number|undefined
  {
    const encodedBounds = image.attr(StageConstants.ATTRIBUTE_BOUNDING_BOX);
    if (! encodedBounds) {
      return undefined;
    }

    const bounds = JSON.parse(
      image.attr(StageConstants.ATTRIBUTE_BOUNDING_BOX));

    const wrapper = (<any>image).parent() as SVG.Doc;

    this.updateImageQualityRating(wrapper, bounds.width);

    return parseInt(image.node.getAttribute(
        StageConstants.ATTRIBUTE_QUALITY_RATING), 10);
  }

  private updateImageQualityRating(element: SVG.Doc, imageWidth: number): void
  {
    element.select('image').first().attr(
        StageConstants.ATTRIBUTE_QUALITY_RATING,
        this.calculateImageQualityRating(element, imageWidth));
  }

  private calculateViewboxFactor(info: PartInfo): number
  {
    const referenceSide = (
      this.stageService.getCurrentStageState().stageConfig.rotation % 180 === 0
        ? info.config.width
        : info.config.height);

    return referenceSide / StageUtils.originalDimensions(info.doc).width;
  }

  private findContainingPart(wrapper: SVG.Doc): PartInfo
  {
    for (const parent of wrapper.parents()) {
      const partId = parent.attr(StageConstants.ATTRIBUTE_PART_ID);
      const fallbackPart = this.designStepService.getDesignablePart();

      if (partId) {
        return {
          config: this
            .designStepService
            .getParts()
            .filter(p => p.id === partId)[0] || fallbackPart,
          doc: parent as SVG.Doc,
        };
      }
    }

    return {
      config: this.designStepService.getPart(),
      doc: (<any>wrapper).doc() as SVG.Doc,
    };
  }

  private calculateImageQualityRating(
      wrapper: SVG.Doc, imageWidth: number): number
  {
    const info = this.findContainingPart(wrapper);
    const factor = this.calculateViewboxFactor(info);
    let targetWidth = wrapper.width();
    let group = (<any>wrapper).parent();
    while (group && group.node.tagName === 'g') {
      targetWidth = targetWidth * group.transform().scaleX;
      group = group.parent();
    }
    targetWidth = targetWidth * factor;

    const qualityInPercent = imageWidth / targetWidth;
    return QualityRating.getQualityByPercent(qualityInPercent);
  }
}



// WEBPACK FOOTER //
// ./src/app/controls/image-quality-rating/image-quality-rating.service.ts